import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import Swiper from "swiper"
import 'swiper/dist/css/swiper.min.css';

import GROBAL_CONFIG from "./config";
// 引入vue-router
import VueRouter from "vue-router";
import router from "./router/index";

import $ from "jquery";

// import "bootstrap/dist/css/bootstrap.css"
// import "bootstrap/dist/js/bootstrap.js"

Vue.use(ElementUI);

require('./responsive');
require('./wx')
import './assets/css/layout.css'



import footer from "./components/Footer"
/*import Childfooter from "./components/ChildFooter"
import relief from "./components/Relief"
import hxrelief from "./components/hxRelief"
import lthxrelief from "./components/ltRelief"
import Childfooter26 from "./components/ChildFooter26"*/

Vue.component('footer-bar', footer);
/*Vue.component('child-footer', Childfooter);
Vue.component('child-footer26', Childfooter26);
Vue.component('relief',relief);
Vue.component('hxrelief',hxrelief);
Vue.component('lthxrelief',lthxrelief);*/
/*import Music from './components/Music'
Vue.component('music-bar', Music);*/




//引入高德地图插件
import VueAMap from 'vue-amap';
import { lazyAMapApiLoaderInstance } from 'vue-amap';

Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
    // 申请的高德key
    key: GROBAL_CONFIG.GDKEY,
    // 插件集合
    plugin: ['Geolocation', 'PlaceSearch', 'ToolBar', 'Autocomplete', 'MapType', 'Driving', 'Transfer', 'Walking', 'Riding'],
});
lazyAMapApiLoaderInstance.load().then(() => {
    // your code ...
    this.map = new AMap.Map('amapContainer', {
        center: new AMap.LngLat(121.59996, 31.197646)
    });
});



Vue.use(VueRouter);
new Vue({
    el: '#app',
    router,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js